import { getAnnouncementImageUrl } from './imageUrl';

/** @see sherlook-frontend-next/src/utils/colissimoLabel.ts */
export function extractEtiquetteUrlFromContent(content: string): string | null {
  const match = content.match(/Etiquette:\s*(\S+)/i);
  if (!match?.[1]) return null;
  const raw = match[1].replace(/[)\].,;!?]+$/g, '').replace(/\.$/, '');
  if (!raw) return null;
  return getAnnouncementImageUrl(raw);
}

export function extractTrackingNumberFromContent(content: string): string | null {
  const match = content.match(/Tracking:\s*([A-Za-z0-9]+)/i);
  return match?.[1] ?? null;
}
